"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _recharts = require("recharts");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Pie = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Pie, _Component);

  var _super = _createSuper(Pie);

  function Pie() {
    (0, _classCallCheck2["default"])(this, Pie);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Pie, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/_react["default"].createElement(_recharts.Pie, this.props, children);
    }
  }]);
  return Pie;
}(_react.Component);

exports["default"] = Pie;
Pie.propDoc = {
  data: {
    required: true,
    type: "ReadonlyArray<any>",
    description: "data for chart"
  },
  dataKey: {
    required: false,
    type: "string",
    description: "The key of each sector's value"
  },
  cx: {
    required: false,
    type: "string | number",
    description: "The x-coordinate of center. If set a percentage, the final" + "value is obtained by multiplying the percentage of container width"
  },
  cy: {
    required: false,
    type: "string | number",
    description: "the y-coordinate of center. If set a percentage, the final value is" + "obtained by multiplying the percentage of container height"
  },
  innerRadius: {
    required: false,
    type: "string | number",
    description: "The inner radius of all the sectors. If set a percentage, the final value is obtained by multiplying the percentage of maxRadius which is calculated by the width, height, cx, cy."
  },
  outerRadius: {
    required: false,
    type: "string | number",
    description: "The outer radius of all the sectors. If set a percentage, the final value is obtained by multiplying the percentage of maxRadius which is calculated by the width, height, cx, cy"
  },
  label: {
    required: false,
    type: "boolean",
    description: "line type (see source code for details/examples)"
  },
  paddingAngle: {
    required: false,
    type: "string | number",
    description: "The angle between two sectors"
  },
  onMouseEnter: {
    required: false,
    type: "function",
    description: "onMouseEnter callback"
  },
  onMouseLeave: {
    required: false,
    type: "function",
    description: "onMouseLeave callback"
  }
};
Pie.defaultProps = {
  dataKey: "value"
};